import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Crown, ArrowRight } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

/** Guest-facing "Sign up free → 15 days of Lumera+" offer (landing + sign-up screen). */
const TrialOfferStrip = ({ language = 'en', variant = 'landing', onSignup }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const es = language === 'es';
  if (user) return null;

  const title = es ? 'Regístrate gratis y obtén 15 días de Lumera+' : 'Sign up free and get 15 days of Lumera+';
  const sub = es
    ? 'Compañero IA ilimitado, sermones, estudios de palabras y voz premium. Sin tarjeta.'
    : 'Unlimited AI Companion, sermon builder, word studies & premium voice. No card needed.';

  if (variant === 'login') {
    return (
      <div className="mb-5 flex items-start gap-3 rounded-xl border border-amber-300/60 bg-amber-50 px-4 py-3 text-left" data-testid="trial-offer-login">
        <Crown className="mt-0.5 h-5 w-5 shrink-0 text-amber-600" />
        <div>
          <p className="text-sm font-semibold text-amber-900">{title}</p>
          <p className="text-xs text-amber-800/80">{sub}</p>
        </div>
      </div>
    );
  }

  return (
    <button
      type="button"
      onClick={() => (onSignup ? onSignup() : navigate('/login?tab=signup'))}
      data-testid="trial-offer-landing"
      className="group mt-6 flex w-full max-w-md items-center gap-3 rounded-2xl border border-[#B0871F]/40 bg-gradient-to-r from-[#B0871F]/10 to-transparent px-4 py-3 text-left transition-colors hover:bg-[#B0871F]/15"
    >
      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#B0871F]/20">
        <Crown className="h-4 w-4 text-[#B0871F]" />
      </span>
      <span className="flex-1">
        <span className="block font-plex text-sm font-semibold text-slate-900">{title}</span>
        <span className="block font-plex text-xs text-slate-600">{sub}</span>
      </span>
      <ArrowRight className="h-4 w-4 text-[#B0871F] transition-transform group-hover:translate-x-0.5" />
    </button>
  );
};

export default TrialOfferStrip;
